import {
  ExternalTransaction,
  ExternalTransactionStatus,
} from '@helios/common-api'
import { FilterModel } from '@helios/filter-modal'
import { composeFieldPath } from '@northfork/basics'

export type ExternalTransactionStatusKey =
  keyof typeof ExternalTransactionStatus

export const externalTransactionField = composeFieldPath(
  [] as ExternalTransaction[],
)

export interface ExternalTransactionSetValues {
  tranTypeCodes: string[]
  securityTypeCodes: string[]
  currencyCodes: string[]
  status: string[]
  dataSourceType: string[]
  accountId: number[]
  accountName: string[]
  predictedAction: string[]
  statusChangedBy: string[]
  collateralBroker: string[]
}

export interface CashEntryUpdatedCwanTransaction
  extends UpdatedCwanTransaction {
  postDate?: string
  amount?: number
}

export interface TradeEntryUpdatedCwanTransaction
  extends UpdatedCwanTransaction {
  entryDate?: string
  settleDate?: string
  postDate?: string
  units?: number
  price?: number
  commission?: number
  accrued?: number
  factor?: number
}

export interface UpdatedCwanTransaction {
  category: TranCategory
}

export enum TranCategory {
  TRADE = 'TRADE',
  TRANSFER = 'TRANSFER',
  CASH_ENTRY = 'CASH_ENTRY',
  FX_TRADE = 'FX_TRADE',
  CURRENCY_FORWARD = 'CURRENCY_FORWARD',
  DIRECT_TRANSFER = 'DIRECT_TRANSFER',
  OTHER = 'OTHER',
}

export type MatchTranCategory = TranCategory.CASH_ENTRY | TranCategory.TRADE

export interface ExportExcelRequest {
  fields: string[]
  headers: string[]
  filter: FilterModel
  userTimeZone: string
}

export interface TransactionAvailableRestrictedColumns {
  column: string
  isAvailable: boolean
}
